import React from "react";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { useParams } from "react-router-dom";
import { useMitutoyoDepartmentDetailsQuery, useMitutoyoDepartmentMembersQuery } from "../../../../../store/organization/organizationSlice";
import { Skeleton } from "../../../../atoms/skeleton";
import { PAGE_NAME } from "../../../../../constants/constants";
import { DataTable } from "../../../../organisms/dataTable";

export const MitutoyoDepartmentDetails = () => {
    const pageClassName = "p-mitutoyoDepartmentDetails";
    const { name } = useParams<{ name: string }>();

    const { data, isLoading } = useMitutoyoDepartmentDetailsQuery(name ?? "", {
        refetchOnMountOrArgChange: true,
    });

    const tableHeader = [
        {
            title: "Serial",
            dataIndex: "id",
            isSortable: false,
        },
        {
            title: "first Name",
            dataIndex: "firstName",
            isSortable: false,
        },
        {
            title: "last Name",
            dataIndex: "lastName",
            isSortable: false,
        },
        {
            title: "Email",
            dataIndex: "email",
        },
        {
            title: "Status",
            dataIndex: "status",
            isSortable: false,
        },
        {
            title: "Organization",
            dataIndex: "organization",
        },
        {
            title: "Saas Tools",
            dataIndex: "toolNames",
            isSortable: false,
        },
    ];


    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>{PAGE_NAME.MITUTOYO_DEPARTMENT_INFO}</p>
            <div className={`${pageClassName}__container`}>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>Name</p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.name ?? "-"}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>Organization Name</p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.organization ?? "-"}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Number of Members
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.numberOfMembers ?? 0}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Okta Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.okta ?? 0}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Youtrack Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.youtrack ?? 0}

                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Box Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.box ?? 0}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Confluence Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.confluence ?? 0}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Atlassian Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.atlassian ?? 0}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Gitlab Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.gitlab ?? 0}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Miro Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? <Skeleton height="small" /> : data?.result?.miro ?? 0}
                    </p>
                </div>

                <DataTable
                    title="Members"
                    id={name as string}
                    tableHeader={tableHeader}
                    useCallApiQuery={useMitutoyoDepartmentMembersQuery}
                />
            </div>
        </div>
    );
};

